import { FC } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Redux
import { useAppSelector } from 'hooks/useStore';
// Selectors
import { selectQuiz } from 'store/quiz/quizSelectors';
import { selectResult } from 'store/player/playerSelectors';
// Components
import { Button } from 'components/Buttons';
// Hooks
import useNavigateTo from 'hooks/useNavigateTo';
import QuizTypes from 'types/QuizTypes';

const LeaderboardButton:FC = () => {
  const { t } = useTranslation('common');
  // State
  const quiz:any = useAppSelector(selectQuiz);
  const result:any = useAppSelector(selectResult);

  const navigateTo = useNavigateTo()

  const handleClick = () => {
    navigateTo('leaderboard');
  }

  if ( quiz.type === QuizTypes.Personality ) return null;
  return (
    <div className="text-center mb-4">
      <Button
        className="capitalize"
        onClick={handleClick}
        disabled={!result}
      >{t('common.leaderboard')}</Button>
    </div>
  )
}

export default LeaderboardButton;
